import React from 'react';
import { ListItemsProps } from './types';

export const ListItems: React.VFC<ListItemsProps> = ({ onMenuNavigationClick, menuItems, chevronIconSvg, activeMenuPage, startPageId }) => {
  return (
    <ul>
      {menuItems.map((item, index) => {
        return (
          <li key={item.pageId} className={item.isCurrentPage ? 'mobile-main-menu__menu-items--selected dark' : ''} data-haschildren={item.hasChildren}>
            {item.isNonClickableInMobile ? (
              <>
                <a href='#' onClick={(e) => {
                  onMenuNavigationClick(e, 'next', item);
                }} className={`ignore-readability-rule ${item.isCurrentPage ? 'ignore-link-focus' : ''}`} >
                  {item.icon !== undefined && item.icon !== '' && item.icon !== null && startPageId !== activeMenuPage.pageId ? (
                    <svg className={`streamline-icon ${item.icon}`}>
                      <use xlinkHref={`${item.icon}`} ></use>
                    </svg>
                  ) : (
                    <></>
                  )}
                  {item.text}</a>
                {item.hasChildren && (
                  <button
                    aria-label={`Visa undersidor till ${item.text}`}
                    className="link-focus"
                    onClick={(e) => {
                      onMenuNavigationClick(e, 'next', item);
                    }}
                    dangerouslySetInnerHTML={{ __html: chevronIconSvg }}></button>
                )}
              </>

            ) :
              (
                <>
                  <a href={item.href} className={`ignore-readability-rule ${item.isCurrentPage ? 'ignore-link-focus' : ''}`}>
                    {item.icon !== undefined && item.icon !== '' && item.icon !== null && startPageId !== activeMenuPage.pageId ? (
                      <svg className={`streamline-icon ${item.icon}`}>
                        <use xlinkHref={`${item.icon}`} ></use>
                      </svg>
                    ) : (
                      <></>
                    )}
                    {item.text}
                  </a>
                  {item.hasChildren && (
                    <button
                      aria-label={`Visa undersidor till ${item.text}`}
                      className="link-focus"
                      onClick={(e) => {
                        onMenuNavigationClick(e, 'next', item);
                      }}
                      dangerouslySetInnerHTML={{ __html: chevronIconSvg }}></button>
                  )}</>
              )
            }

          </li>
        );
      })}
    </ul>
  );
};
